// const CUSTOMER_PRODUCTION_URI = 'https://customer.capitual.com/graphql';

const prod = 'https://bizbff.capitual.com/graphql';
const dev = 'https://stagingbizbff.capitual.io/graphql';

export const ENDPOINT = import.meta.env.VITE_NODE_ENV === 'prod' ? prod : dev;
